<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               {{$t('WIKIS')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('CATEGORY')">
                    <b-form-select :options="categories.root" v-model="pagination.categoryId" value-field="categoryId" text-field="categoryName"></b-form-select>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('LANGUAGE')">
                    <b-form-select :options="languages.root" v-model="pagination.langId" value-field="langId" text-field="langName"></b-form-select>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('WIKIID')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('HEADER')}}</th>
                    <th>{{$t('CATEGORY')}}</th>
                    <th>{{$t('DATETIME')}}</th>
                    <th>{{$t('EDIT')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in data.root" :key="key">
                    <td>{{item.wikiId}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.header}}</td>
                    <td>{{item.categoryName}}</td>
                    <td>{{item.dateTime}}</td>
                    <td><router-link :to="'/admin/sitecontent/'+item.wikiId+'/editwiki'" class="btn btn-primary btn-sm">{{$t('EDIT')}}</router-link></td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.wikiId)"><icon icon="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/admin/Wiki'
import ApiLang from '@/api/admin/TransLang'
import ApiCats from '@/api/admin/WikiCategory'

export default {
  name: 'Wikis',
  data: function()
  {
    return {
      data: {},
      formError: {},
      formData:
      {
        name: '',
        content: ''
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false,
        langId: 2,
        categoryId: null
      },
      categories: {},
      languages: {}
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
    me.getLanguagesData();
    me.getCatsData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.categoryId != 'undefined')
      {
        item.id = item.categoryId;
        delete(item.categoryId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.data = data;
      });
    },
    getLanguagesData: function()
    {
      var me = this;
      ApiLang.selectRow({start: 0, limit: 100}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.languages = data;
      });
    },
    getCatsData: function()
    {
      var me = this;
      ApiCats.selectRow({start: 0, limit: 100}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.categories = data;
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.categoryId': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.langId': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
